export default "__VITE_ASSET__BULJT5Cs__"